module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDY4IDQ4Ij4KICA8ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC42MDMpIiBmaWxsPSJ3aGl0ZSI+CiAgICA8cG9seWdvbiBwb2ludHM9IjQzLjg0NCAwIDQzLjg0NCAxMC4xMDggNTcuMjIzIDEwLjEwOCA1Ny4yMjMgMjMuNTE5IDY3LjMwNCAyMy41MTkgNjcuMzA0IDAiLz4KICAgIDxwb2x5Z29uIHBvaW50cz0iMCAyMy41MiAwIDQ3LjA0IDIzLjQ1OSA0Ny4wNCAyMy40NTkgMzYuOTMxIDEwLjA4IDM2LjkzMSAxMC4wOCAyMy41MiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon_fullscreen.svg
// module id = lrUB
// module chunks = 1